import { mapState } from 'vuex';
import CONST from '@/utils/Constants'
import eventBus from '@/config/EventBus'
import LayoutTablet from "@/layouts/tablet/layout-tablet.vue"
import oBlock from "@/objects/o-block/o-block.vue"

export default {
  name: "vDrawingReady",
  components: {
    "layout-tablet": LayoutTablet,
    "o-block": oBlock
  },
  data() {
    return {}
  },
  computed: {
    ...mapState(['locale']),
    content() {
      return this.$store.getters.content;
    },
    src() {
      return this.$store.state.drawing;
    },
    count() {
      return this.$store.state.drawings_count;
    }
  },
  mounted() {
    setTimeout(function(){
      // dispatch 'stop' event
      eventBus.$emit(CONST.EVENT.DRAWING.SENT);
    }, 8000);
  }
}
